<template>
  <div class="" v-loader.opacity.tab="loading">
    <div class="clinic-schedule-list" id="schedule-list" v-if="!isEdit && !isHistory">
      <BaseTable class="no-border" v-if="tableSchedules" :tabledata="tableSchedules" @item-opened="toDetails">
        <template v-slot:column_type="{item}">
          <span>{{ typeLabel(item.type) }}</span>
          <span class="schedule-period" :class="{'is-not-synced': item.notSynced}">{{ periodLabel(item) }}</span>
        </template>
        <template v-slot:column_frequency="{item}">
          <span>{{ frequencyLabel(item.frequency) }}</span>
        </template>
        <template v-slot:column_status="{item}">
          <span class="badge" :class="item.enabled ? 'bg-success' : 'bg-secondary'">
            {{ item.enabled ? $t('schedule.statusEnabled') : $t('schedule.statusDisabled') }}
          </span>
        </template>
        <template v-slot:column_lastExecution="{item}">
          <span class="last-execution-never" v-if="!item.lastExecution">{{ $t('schedule.neverRan') }}</span>
          <template v-else>
            <span class="badge" :class="lastExecutionClass(item)" :title="item.lastExecution.errorMessage || ''">
              {{ lastExecutionLabel(item) }}
            </span>
            <span class="last-execution-date">{{ lastExecutionDate(item) }}</span>
          </template>
        </template>
        <template v-slot:column_actions="{item}">
          <button class="btn btn-sm btn-outline-primary"
                  type="button"
                  name="button"
                  data-test="btnScheduleHistory"
                  @click.stop="showHistory(item)">
            <i class="fa fa-history"></i>
            <span>{{ $t('schedule.history') }}</span>
          </button>
          <button v-if="triggerEnabled"
                  class="btn btn-sm btn-outline-primary"
                  type="button"
                  name="button"
                  data-test="btnTriggerSchedule"
                  :disabled="triggeringUuid === item.uuid"
                  @click.stop="triggerNow(item)">
            <i class="fa fa-play"></i>
            <span>{{ $t('schedule.triggerNow') }}</span>
          </button>
        </template>
      </BaseTable>
    </div>

    <div class="clinic-edit-box" v-else-if="isHistory">
      <ClinicScheduleHistory
        :clinic_id="clinic_id"
        :schedule="selectedSchedule"
        @close-history="closeHistory"/>
    </div>

    <div class="clinic-edit-box" v-else>
      <ClinicScheduleEdit
        :clinic_id="clinic_id"
        :schedule="selectedSchedule"
        @cancel-edit="cancelEdit"
        @saved="onSaved"/>
    </div>

    <div class="action-bar" v-if="!isEdit && !isHistory">
      <button class="btn btn-success" type="button" name="button" data-test="btnNewSchedule" @click="newSchedule">
        <span>{{ $t('schedule.new') }}</span>
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.clinic-schedule-list {
  padding:                         0 10px 10px 10px;
}

.last-execution-date,
.last-execution-never,
.schedule-period {
  color:                           var(--Shades-70);
}

.last-execution-date,
.schedule-period {
  display:                         block;
  font-size:                       0.85em;
}

.schedule-period.is-not-synced {
  color:                           var(--Brand-Primary-BG);
  font-weight:                     600;
}

@media (max-width: 991px) {
  .clinic-schedule-list {
    height:                        calc(100dvh - 258px);
    max-height:                    calc(100dvh - 258px);
    padding:                       0;
  }
}

@media screen and (min-width: 992px) and (max-width: 1365px) {
  .clinic-schedule-list {
    height:                        calc(100dvh - 303px);
  }
}
</style>

<script src="./ClinicSchedulesTab.js"></script>
